module.exports = __webpack_public_path__ + "img/footer.306374ad.png";